/** API route map: URLS.Controller.EmployeeExperience */
export const EmployeeExperience = {
      Name: 'EmployeeExperience/',
      GetExperiences: 'get-all',
      AddExperience: 'add',
      UpdateExperience: 'update',
      DeleteExperience: 'delete',
};
